import { useEffect, useState } from 'react'
import toast, { Toaster } from 'react-hot-toast'
import { useNavigate } from 'react-router-dom'
import { http } from '../AxiosConfig'
import { feedbackOptions } from '../data'
import FormLoader from './FormLoader/FormLoader'

const FeedBacksForm = () => {
  const navigate = useNavigate()
  const [isLoading, setIsLoading] = useState(false)
  const [formValues, setFormValues] = useState({})

  const getFormsInput = () => {
    const params = { ...formValues }
    return { feedback: params }
  }

  const handleSubmit = e => {
    e.preventDefault()
    const formData = getFormsInput()
    feedbackSubmittion(formData)
    console.log(formData)
  }
  const feedbackSubmittion = () => {
    setIsLoading(true)
    http
      .post(`/feedbacks`, getFormsInput())
      .then(res => {
        setIsLoading(false)
        console.log('res', res)
        if (res.status === 200) {
          toast.success('Feedback submitted successfully.')
          navigate(-1)
        }
      })
      .catch(err => {
        setIsLoading(false)
        console.log('err', err)
        if (err.request.status) {
          toast.error(`Email not on file, ${err.message}`)
        }
      })
      .finally(() => {
        setIsLoading(false)
      })
  }
  const handleChange = e => {
    const { name, value } = e.target
    setFormValues({ ...formValues, [name]: value })
  }
  useEffect(() => {}, [formValues])
  return (
    <div className="grid grid-cols-1">
      <Toaster position="top-center" reverseOrder={false} />
      <form onSubmit={handleSubmit}>
        <div className="items-center mt-8">
          <div className="w-full flex flex-col">
            <label
              htmlFor="email"
              className="font-semibold leading-none text-gray-300"
            >
              Email
            </label>
            <input
              // value={formValues.email}
              onChange={handleChange}
              id="email"
              name="email"
              type="email"
              placeholder="Email address"
              required
              autoFocus
              className="primary-input"
            />
          </div>
          <div className="md:flex items-center mt-4">
            <div className="w-full flex flex-col">
              <select
                onChange={handleChange}
                id="type"
                className="reimbursement-input"
                name="type"
                required
              >
                {feedbackOptions.map(c => (
                  <option key={c.value} value={c.value}>
                    {c.text}
                  </option>
                ))}
              </select>
              <textarea
                onChange={handleChange}
                // value={reimbursementFormValues.notes}
                id="content"
                name="content"
                placeholder="Comments, questions, suggestions are all welcome with any relevant details."
                className="reimbursement-input"
                type="text"
                required
              ></textarea>
            </div>
          </div>
          {isLoading ? (
            <button id="continue-button-loader" className="primary-button">
              <FormLoader message={`Loading`} />
            </button>
          ) : (
            <button
              id="continue-button-selector"
              className="primary-button"
              type="submit"
            >
              Submit
            </button>
          )}
        </div>
      </form>
    </div>
  )
}

export default FeedBacksForm
